import React from "react"
import style from "./style.module.scss"
import { SimplifiedNews } from "types/news"
import { Row, Col } from "react-bootstrap"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import homeNews from "@assets/images/title-banner/home-news.png"
import NewsList from "../NewsList"
import Pagination from "@components/UI/Pagination"

type Props = {
  authorNews: SimplifiedNews[]
  pageNum: number
  pages: number
  onPageChange: (page: number) => string
  authorName: string
}

function AuthorNews({ authorNews, pageNum, pages, onPageChange, authorName }: Props) {
  return (
    <div className={style.mainPage}>
      <Row className={"marginZero"}>
        <Col md={12} className={"paddingLeftRightFive"}>
          <NewTitleBanner icon={homeNews} title={`Articoli di ${authorName}`} col={{ lg: 12 }} />
          <Row xl={3} lg={3} md={2} sm={12} xs={12}>
            <NewsList news={authorNews} />
          </Row>
          <Row className={"page-desktop-row page-mobilegit-row"}>
            <Pagination page={pageNum} pageCount={pages} onChange={onPageChange} />
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default AuthorNews
